import { useTranslation } from 'react-i18next'

import { Box } from '@mui/material'

import { Testimonial } from '@pages/LandingPage/components/Testimonial'

import { containerSx, contentSx, testimonialContainerSx } from './styles'

const Testimonial2Section = () => {
  const { t } = useTranslation()

  return (
    <Box data-testid="features-testimonial-2-section" sx={containerSx}>
      <Box sx={contentSx}>
        <Testimonial
          variant="dark"
          testimonialText={t(
            'The marketplace has been great. We’ve signed on new partners from it. We want to make sure what we use is the best and a lot of times, you match us to better partners than we could find on our own - and you make it so simple, easy and fast.'
          )}
          personName="Mark H."
          personPosition={t('Director of IT')}
          containerSx={testimonialContainerSx}
        />
      </Box>
    </Box>
  )
}

export { Testimonial2Section }
